import en from "./en";

export default {
  ...en,
  metaTitleBrand: "LOYA SPORT",
  metaTitleHome: "Accueil",
  metaTitleProducts: "Produits",
  metaTitleProductDetail: "Détail du produit",
  metaTitleCustomService: "Service sur mesure",
  metaTitleSolutions: "Solutions",
  metaTitleAbout: "Profil de l'entreprise",
  metaTitleContact: "Nous contacter",
  metaTitleBlog: "Blog",
  metaTitleLogin: "Connexion",
  metaTitleAdmin: "Tableau de bord administrateur",
  metaTitleSystemSetup: "Configuration du système",
  authLogin: {
    ...en.authLogin,
    welcomeBack: "Bon retour",
    brandIntro: "Connectez-vous pour poursuivre vos achats de produits de yoga et de fitness.",
    brandBullet1: "Flux RFQ rapide",
    brandBullet2: "Suivi des produits et des commandes",
    brandBullet3: "Support des comptes B2B",
    accountLogin: "Connexion au compte",
    createAccount: "Créer un compte",
    recoverPassword: "Récupérer le mot de passe",
    registrationComplete: "Inscription terminée",
    passwordUpdated: "Mot de passe mis à jour",
    loginDesc: "Utilisez votre nom d'utilisateur ou votre e-mail et votre mot de passe pour continuer.",
    registerDesc: "Créez votre compte avec nom d'utilisateur, vérification e-mail et protection captcha.",
    forgotDesc: "Saisissez l'e-mail de votre compte pour recevoir un code de réinitialisation et définir un nouveau mot de passe.",
    registerSuccessDesc: "Votre compte a été créé avec succès. Nous reviendrons automatiquement à l'écran de connexion.",
    resetSuccessDesc: "Votre mot de passe a été mis à jour avec succès. Nous reviendrons automatiquement à l'écran de connexion.",
    redirectHintPrefix: "La page reviendra à l'écran de connexion dans",
    redirectHintSuffix: ".",
    seconds: "secondes",
    loginNow: "Se connecter maintenant",
    username: "Nom d'utilisateur",
    usernamePlaceholder: "Au moins 3 caractères, par exemple loya_buyer",
    usernameHelp: "Le nom d'utilisateur doit comporter au moins 3 caractères, ne pas utiliser de mots réservés et ne peut contenir que des lettres, chiffres, underscores et tirets.",
    usernameExistsHint: "Ce nom d'utilisateur est déjà enregistré. Connectez-vous directement ou choisissez-en un autre.",
    usernameExists: "Le nom d'utilisateur existe déjà. Choisissez-en un autre ou connectez-vous directement.",
    usernameExistsAction: "Nom déjà utilisé, aller à la connexion",
    usernameAlreadyRegistered: "Ce nom d'utilisateur est déjà enregistré.",
    usernameAvailable: "Nom d'utilisateur disponible.",
    usernameVerifyFailed: "Impossible de vérifier le nom d'utilisateur pour le moment. Veuillez réessayer.",
    checkingUsername: "Vérification de la disponibilité du nom d'utilisateur...",
    email: "E-mail",
    emailPlaceholder: "your@email.com",
    emailCodeTargetHint: "Saisissez l'e-mail que vous souhaitez utiliser pour recevoir le code de vérification.",
    emailExistsHint: "Cet e-mail est déjà enregistré. Connectez-vous directement ou utilisez un autre e-mail.",
    emailExists: "Cet e-mail existe déjà. Utilisez un autre e-mail ou allez à la connexion.",
    emailExistsAction: "E-mail déjà utilisé, aller à la connexion",
    emailAlreadyRegistered: "Cet e-mail est déjà enregistré.",
    emailAvailable: "E-mail disponible.",
    emailVerifyFailed: "Impossible de vérifier l'e-mail pour le moment. Veuillez réessayer.",
    checkingEmail: "Vérification de la disponibilité de l'e-mail...",
    usernameOrEmail: "Nom d'utilisateur ou e-mail",
    usernameOrEmailPlaceholder: "nom d'utilisateur ou your@email.com",
    forgotEmailHint: "Saisissez l'e-mail lié à votre compte afin que nous puissions envoyer un code de réinitialisation.",
    password: "Mot de passe",
    passwordPlaceholder: "Saisir le mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    confirmPasswordPlaceholder: "Ressaisir le mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    confirmNewPasswordPlaceholder: "Ressaisir le nouveau mot de passe",
    nickname: "Pseudo",
    nicknamePlaceholder: "Optionnel, utilisé pour l'affichage",
    captcha: "Captcha",
    registerCaptcha: "Captcha d'inscription",
    resetCaptcha: "Captcha de réinitialisation",
    refreshCaptcha: "Rafraîchir le captcha",
    load: "Charger",
    forgotCaptchaHint: "Complétez d'abord le captcha, puis demandez le code de réinitialisation. Après l'envoi, un nouveau captcha sera chargé automatiquement pour l'étape finale.",
    registerCaptchaHint: "Complétez d'abord le captcha, puis demandez le code de vérification e-mail.",
    registerStepHint: "Renseignez d'abord nom d'utilisateur, mot de passe, confirmation et e-mail valide. Ensuite la section captcha et code e-mail apparaîtra.",
    emailCode: "Code e-mail",
    emailCodePlaceholder: "Code à 6 chiffres",
    resetCode: "Code de réinitialisation",
    resetCodePlaceholder: "Code de réinitialisation à 6 chiffres",
    sending: "Envoi en cours...",
    resendIn: "Renvoyer dans",
    sendEmailCode: "Envoyer le code e-mail",
    sendResetCode: "Envoyer le code de réinitialisation",
    signingIn: "Connexion en cours...",
    login: "Se connecter",
    updating: "Mise à jour...",
    creating: "Création...",
    resetPassword: "Réinitialiser le mot de passe",
    forgotRequirementHint: "La récupération du mot de passe nécessite la vérification captcha et le code de réinitialisation envoyé par e-mail.",
    registerRequirementHint: "L'inscription nécessite le code envoyé dans votre boîte de réception.",
    captchaRefreshHint: "Si le captcha est difficile à lire, cliquez sur l'image de droite pour le rafraîchir.",
    switchToLogin: "Vous avez déjà un compte ? Connectez-vous",
    switchToRegister: "Pas encore de compte ? Inscrivez-vous",
    backToLogin: "Retour à la connexion",
    forgotPassword: "Mot de passe oublié ?",
    usernameRequired: "Saisissez un nom d'utilisateur d'au moins 3 caractères.",
    usernameMin: "Le nom d'utilisateur doit contenir au moins 3 caractères.",
    usernameMax: "Le nom d'utilisateur doit contenir 24 caractères maximum.",
    usernamePattern: "Le nom d'utilisateur ne peut contenir que des lettres, chiffres, underscores et tirets.",
    usernameReserved: "Ce nom d'utilisateur est réservé. Veuillez en choisir un autre.",
    usernameFormatOk: "Le format du nom d'utilisateur est valide.",
    emailRequired: "Saisissez une adresse e-mail.",
    emailInvalid: "Saisissez une adresse e-mail valide.",
    emailFormatOk: "Le format de l'e-mail est valide.",
    emailProviderHint: "Utilisez de préférence un fournisseur courant comme Gmail, Outlook, QQ Mail, 163, 126 ou Foxmail.",
    didYouMean: "Vouliez-vous dire",
    passwordMin: "Le mot de passe doit contenir au moins 6 caractères.",
    newPasswordMin: "Le nouveau mot de passe doit contenir au moins 6 caractères.",
    confirmPasswordRequired: "Saisissez le mot de passe de confirmation.",
    passwordMatch: "Les mots de passe correspondent.",
    passwordMismatch: "Les deux mots de passe ne correspondent pas.",
    emailCodeRequired: "Saisissez le code de vérification e-mail.",
    resetCodeRequired: "Saisissez le code de réinitialisation envoyé à votre e-mail.",
    captchaRequired: "Saisissez le code captcha.",
    registerPrerequisitesError: "Renseignez nom d'utilisateur, mot de passe, confirmation et e-mail valide avant de demander le code e-mail.",
    enterCaptchaBeforeEmailCode: "Saisissez le captcha avant de demander le code de vérification e-mail.",
    enterCaptchaBeforeResetCode: "Saisissez le captcha avant de demander le code de réinitialisation du mot de passe.",
    sendEmailCodeFailed: "Échec de l'envoi du code de vérification par e-mail. Veuillez réessayer.",
    emailCodeSent: "Le code de vérification par e-mail a été envoyé.",
    registerFailed: "Échec de l'inscription",
    resetFailed: "Échec de la réinitialisation du mot de passe",
    loginFailed: "Échec de la connexion",
    registerSuccessNotice: "Inscription réussie. Retour à l'écran de connexion dans environ 4 secondes.",
    resetSuccessNotice: "Réinitialisation réussie. Retour à l'écran de connexion dans environ 1,5 seconde.",
    loginTokenMissing: "Jeton de connexion manquant",
    profileLoadFailed: "Impossible de charger le profil du compte",
    loginSuccessAdmin: "Connexion réussie. Redirection en cours...",
    loginSuccessStorefront: "Connexion réussie. Redirection vers la vitrine...",
    loginServiceUnavailable: "Le service de connexion est temporairement indisponible. Veuillez réessayer dans un instant.",
    accountNotFound: "Compte introuvable. Vérifiez votre nom d'utilisateur ou votre e-mail.",
    passwordIncorrect: "Mot de passe incorrect. Veuillez réessayer.",
    registrationNotOpen: "La connexion et l'inscription sont actuellement fermées.",
    accountRestricted: "Cet compte est restreint. Contactez l'administrateur.",
    captchaExpired: "Le captcha a expiré. Veuillez rafraîchir et réessayer.",
    captchaIncorrect: "Le code captcha est incorrect. Veuillez réessayer.",
    passwordRequired: "Veuillez saisir un mot de passe.",
    emailCodeSentInbox: "Le code de vérification a été envoyé. Veuillez vérifier votre boîte de réception.",
    previewCodeCurrentEnv: "Code de prévisualisation pour l'environnement actuel",
    previewCodeDevelopment: "Code de prévisualisation pour le développement",
    previewCodeGenerated: "Le code de vérification a été généré. Cet environnement utilise un code de prévisualisation.",
    previewCodeContinueRegistration: "Saisissez ce code à 6 chiffres pour continuer l'inscription.",
    tooManyRequests: "Trop de requêtes. Veuillez réessayer plus tard.",
    smtpConfigRetry: "Échec de l'envoi de l'e-mail. Vérifiez la configuration SMTP et réessayez.",
    emailServiceNotConfigured: "Le service de messagerie n'est pas configuré. Contactez l'administrateur.",
    requestFailed: "La requête a échoué. Veuillez réessayer ou contacter le support.",
    orContinueWith: "Ou continuer avec",
    googleAuthorizing: "Autorisation du compte Google...",
    googleFallbackAction: "Continuer avec Google",
    googleAuthFailed: "L'authentification Google a échoué",
    googleAuthOffline: "La connexion Google n'est pas disponible hors ligne. Connectez-vous à Internet ou utilisez un identifiant/mot de passe.",
    googleAuthTimeout: "La vérification Google a expiré. Veuillez réessayer. Si le problème persiste, demandez à l'administrateur de vérifier l'accès réseau sortant du serveur.",
    googleAuthNetworkError: "La vérification Google a échoué à cause d'une erreur réseau serveur. Contactez l'administrateur.",
    googleRegisterSuccess: "Compte Google lié avec succès. Redirection vers la vitrine...",
    googleCreateAccountTitle: "Complétez votre inscription Google",
    googleCreateAccountDesc: "Google a vérifié votre e-mail. Définissez un mot de passe pour créer votre compte client et finaliser la connexion.",
    googleCreateAccountHint: "Aucun compte n'existe pour cet e-mail Google. Définissez un mot de passe pour créer votre compte client.",
    googleLinkedEmailHint: "Cet e-mail Google vérifié sera utilisé pour créer votre compte client.",
    googleCreatePasswordHint: "Définissez et confirmez un mot de passe. Le nouveau compte client utilisera votre e-mail vérifié par Google."
  },

  // --- storefront ---
  navHome: "Accueil",
  navProducts: "Produits",
  navCustomization: "Service sur mesure",
  navSolutions: "Solutions",
  navAbout: "Profil de l'entreprise",
  navContact: "Nous contacter",

  navYogaMats: "Tapis de yoga",
  navYogaBlocks: "Blocs de yoga",
  navYogaStraps: "Sangles de yoga",
  navResistanceBands: "Bandes de résistance",
  navPilatesRings: "Anneaux de Pilates",
  navFoamRollers: "Rouleaux en mousse",
  navOemPrivateLabel: "Service sur mesure",
  navSolutionsControl: "Contrôle qualité",
  navCompanyProfile: "Profil de l'entreprise",
  navContactUs: "Nous contacter",
  navBlog: "Blog",
  
  btnContactUs: "Nous contacter",
  btnLogin: "Se connecter",
  btnAccount: "Compte",
  btnQuote: "Demander un devis",
  btnCurrency: "Devise",
  btnLanguage: "Langue",

  seeAllCategories: "Voir toutes les catégories",
  productDetailReady: "Prêt pour marque privée",
  productDetailQuote: "Devis sur demande",
  productDetailViewSpecs: "Voir les spécifications",
  productDetailRequestQuote: "Demander un devis",
  pdLoadErrorProductDetail: "Échec du chargement du détail produit",
  pdLoadErrorRelatedProducts: "Échec du chargement des produits associés",
  pdLoadErrorStorefrontConfig: "Échec du chargement de la configuration de la vitrine",
  pdLoading: "Chargement du détail produit...",
  pdSampleDefaultMessage: "Veuillez partager la politique d'échantillon, le délai et les détails de devis.",
  pdAttrProductName: "Nom du produit",
  pdAttrModelNo: "N° modèle",
  pdAttrCategory: "Catégorie",
  pdAttrManufacturer: "Fabricant",
  pdLeadTimeOnRequest: "Délai sur demande",
  pdLeadTimeUpTo: "Jusqu'à {qty} pièces : {days} jours",
  pdLeadTimeFrom: "{qty}+ pièces : {days} jours",
  pdLeadTimeDaysOnly: "{days} jours",
  pdContactForQuote: "Nous contacter pour un devis",
  pdPerPiece: "{price} / pièce",
  pdAnonymousBuyer: "Acheteur anonyme",
  pdReviewTipSignIn: "Connectez-vous en tant que client pour voter utile.",
  pdReviewTipSessionExpired: "Session expirée. Veuillez vous reconnecter.",
  pdReviewTipNoPermission: "Le compte actuel ne peut pas voter utile.",
  pdReviewTipUpdateFailed: "Échec de la mise à jour du statut utile",
  pdSpecValues: "Valeurs",
  pdSpecRequired: "Obligatoire",
  pdSpecOptional: "Optionnel",
  pdCapabilityCustomLogo: "Application de logo personnalisée",
  pdCapabilitySampleDev: "Développement basé sur échantillon",
  pdCapabilityPackagingCoordination: "Coordination d'emballage",
  pdCapabilityExportFollowUp: "Suivi d'expédition export",
  pdPackagingSellingUnit: "Unité de vente",
  pdPackagingSingleItem: "Article unitaire",
  pdPackagingType: "Emballage",
  pdPackagingTypeFallback: "Sac OPP / carton export",
  pdPackagingLoadingAdvice: "Conseil de chargement",
  pdPackagingLoadingAdviceFallback: "Selon la structure de commande",
  pdPackagingLeadTime: "Délai",
  pdMediaPhotoLabel: "Photo {index}",
  pdMediaVideoLabel: "Vidéo",
  pdMediaAttributesLabel: "Attributs",
  pdPackagingPointPackaging: "Emballage : {value}",
  pdPackagingPointLoadingAdvice: "Conseil de chargement : {value}",
  pdPackagingPointShippingPort: "Port d'expédition : {value} (négociable)",
  pdPackagingPointShippingPortNegotiable: "Port d'expédition : négociable",
  pdPackagingPointLeadTime: "Délai : {value}",
  pdInquiryHello: "Bonjour, je souhaite demander des informations sur :",
  pdInquiryProduct: "Produit : {value}",
  pdInquirySku: "SKU : {value}",
  pdInquirySkuName: "Nom SKU : {value}",
  pdInquiryModel: "Modèle : {value}",
  pdInquiryQuantity: "Quantité : {value}",
  pdEmailSubject: "Demande : {sku} - {name}",
  pdInquirySubmitFailed: "Impossible d'envoyer la demande pour le moment.",
  pdSampleContactPerson: "Contact : {value}",
  pdSampleWhatsapp: "WhatsApp/WeChat : {value}",
  pdSampleCompany: "Entreprise : {value}",
  pdSampleRequestedQuantity: "Quantité demandée : {value}",
  pdSampleSelectorQuantity: "Sélecteur de quantité page : {value}",
  pdVariationLabel: "Option",
  pdVariationInquiryIntro: "Bonjour, je souhaite envoyer une demande pour :",
  pdVariationInquiryQuoteLeadTime: "Veuillez partager le dernier devis et le délai.",
  pdVideoFallback: "Échec du chargement de la vidéo. Veuillez réessayer ou ouvrir la source.",
  pdRetry: "Réessayer",
  pdOpenVideoUrl: "Ouvrir l'URL vidéo",
  pdProductAttributes: "Attributs produit",
  pdMediaTabsAria: "Types de médias produit",
  pdMediaTabPhotos: "Photos",
  pdMediaTabVideo: "Vidéo",
  pdMediaTabAttributes: "Attributs",
  pdInfoTabsAria: "Onglets d'information détaillée",
  pdInfoTabAttributes: "Attributs",
  pdInfoTabDescription: "Description",
  pdInfoTabSupplier: "Fournisseur",
  pdInfoTabReviews: "Avis",
  pdKeyAttributes: "Attributs clés",
  pdPackagingShippingInfo: "Informations emballage et expédition",
  pdProductDescription: "Description du produit",
  pdSupplierOverview: "Aperçu fournisseur",
  pdSupplierOverviewHint: "Le profil société et la FAQ sont affichés sous les images de détail.",
  pdBuyerFeedback: "Retours acheteurs",
  pdRepeatBuyer: "Acheteur récurrent",
  pdReviewRatingAria: "Note {rating} sur 5",
  pdReviewMetaColor: "couleur : {value}",
  pdReviewMetaColorFallback: "deuxième",
  pdReviewUnavailable: "Ce produit n'est plus disponible",
  pdReviewHelpful: "Utile ({count})",
  pdNoReviews: "Pas encore d'avis pour ce produit.",
  pdNoReviewsHint: "Contactez notre équipe pour des références de commandes ou des retours d'échantillons.",
  pdTitleFallback: "Détail du produit",
  pdCustomizable: "Personnalisable",
  pdVariationCardAria: "Variantes du produit",
  pdVariations: "Variantes",
  pdSelectNow: "Sélectionner maintenant",
  pdSelectOption: "Sélectionner une option",
  pdLadderPricingAria: "Tarification par paliers",
  pdProductSpecifications: "Spécifications du produit",
  pdSpecPrevAria: "Afficher la valeur de spécification précédente",
  pdSpecNextAria: "Afficher la valeur de spécification suivante",
  pdSupplierCapability: "Capacité de personnalisation du fournisseur",
  pdGetFreeSample: "Obtenir un échantillon gratuit",
  pdWhatsAppInquiry: "Demande WhatsApp",
  pdEmailInquiry: "Demande e-mail",
  pdPackagingDelivery: "Emballage & livraison",
  pdProductVideo: "Vidéo produit",
  pdVideoOpenLink: "La vidéo ne peut pas être lue dans le contexte actuel.",
  pdSupplierDescriptions: "Descriptions produit du fournisseur",
  pdCompanyIntroduction: "Présentation de l'entreprise",
  pdNoCompanyIntroduction: "Aucune présentation d'entreprise configurée.",
  pdFaq: "FAQ",
  pdNoFaq: "Aucune FAQ configurée.",
  pdCloseVariationSelector: "Fermer le sélecteur de variation",
  pdVariationSelectAndQty: "Sélectionner variantes et quantité",
  pdVariationStock: " / stock {count}",
  pdSelectedQuantity: "Quantité sélectionnée",
  pdSendInquiry: "Envoyer la demande",
  pdChatNow: "Discuter maintenant",
  pdOptionLabel: "Option {index}",
  pdRelatedAria: "Produits associés",
  pdRelatedTitle: "Produits associés",
  pdRelatedSubtitle: "Plus d'articles souvent achetés ensemble dans cette catégorie.",
  pdRelatedPrevAria: "Produits associés précédents",
  pdRelatedNextAria: "Produits associés suivants",
  pdSampleContactTitle: "Veuillez nous contacter",
  pdSampleContactDesc: "Des questions ? Nous sommes heureux de vous aider. Contactez-nous via WhatsApp ou e-mail pour l'assistance échantillon.",
  pdSampleCloseAria: "Fermer la demande d'échantillon",
  pdSampleSummaryProduct: "Produit",
  pdSampleSummaryQuantity: "Quantité",
  pdFormFullName: "Nom complet",
  pdFormFullNamePlaceholder: "Votre nom",
  pdFormEmail: "E-mail*",
  pdFormEmailPlaceholder: "Vous contacter par e-mail",
  pdFormWhatsapp: "WhatsApp/WeChat*",
  pdFormWhatsappPlaceholder: "Vous contacter via WhatsApp",
  pdFormCompany: "Nom de votre entreprise",
  pdFormCompanyPlaceholder: "Nom de votre entreprise",
  pdFormRequiredQuantity: "Quantité requise",
  pdFormRequiredQuantityPlaceholder: "Quantité d'échantillon ou d'essai requise",
  pdFormMessage: "Message",
  pdFormMessagePlaceholder: "Décrivez brièvement vos exigences produit",
  pdFormSending: "Envoi...",
  pdFormSendMessage: "Envoyer le message",
  pdFormInquirySuccess: "Demande envoyée avec succès.",

  carouselLoadingTitle: "Chargement des images de bannière",
  carouselLoadingBody:
    "Nous préparons les visuels de la page d'accueil pour vous. Veuillez patienter pendant le chargement des images de bannière.",
  carouselPlaceholderTitle: "Les images de bannière sont en cours de préparation",
  carouselPlaceholderBody:
    "Le carrousel de la page d'accueil apparaîtra ici une fois les ressources d'image prêtes.",

  // --- OEM / custom service ---
  oemHeroKicker: "Service sur mesure",
  oemTitle: "Créez une gamme de yoga personnalisée avec un flux de production clair",
  oemIntro:
    "Nous accompagnons les acheteurs internationaux avec la personnalisation produit, le développement d'emballage, le suivi des échantillons et l'exécution des commandes pour les catégories yoga et fitness léger.",
  oemStartProject: "Démarrer votre projet sur mesure",
  oemBrowseProducts: "Parcourir les produits de base",
  oemVisualGuide: "Guide visuel de personnalisation",
  oemVisualAlt: "Guide des options de personnalisation OEM et du processus",
  oemVisualPlaceholder:
    "Image de personnalisation introuvable. Ajoutez votre fichier dans frontend/public/assets/about/oem-customization-guide.jpg",
  oemCapabilityKicker: "Ce que nous pouvons personnaliser",
  oemCapabilityTitle: "De l'application du logo à l'exécution complète de l'emballage",
  oemProjectBrief: "Résumé du projet",

  oemCapability1:
    "Impression de logo, gaufrage et marquage laser personnalisés pour les principaux accessoires de yoga.",
  oemCapability2:
    "Ajustements de couleur, matériau, texture et taille selon votre marché cible.",
  oemCapability3:
    "Emballages prêts à la vente, cartes d'insertion, étiquettes code-barres et marquages de carton.",
  oemCapability4:
    "Développement de packs groupés pour ensembles studio, packs prêts pour Amazon et promotions saisonnières.",

  oemProcess1Title: "Partagez votre idée",
  oemProcess1Body:
    "Envoyez les produits visés, les fichiers logo, les images de référence, les attentes d'emballage et la quantité estimée.",
  oemProcess2Title: "Confirmer les spécifications et la MOQ",
  oemProcess2Body:
    "Nous examinons les options de matériaux, la méthode de branding, les points de conformité, le délai de production et la quantité de départ réalisable.",
  oemProcess3Title: "Échantillonnage et révision",
  oemProcess3Body:
    "Nous préparons des échantillons ou maquettes, recueillons vos retours et validons le standard de production avant acompte.",
  oemProcess4Title: "Production de masse et inspection",
  oemProcess4Body:
    "La production suit l'échantillon approuvé, avec contrôle de l'emballage et vérification qualité avant expédition.",

  // --- news ---
  newsHeroKicker: "Actualités du secteur",
  newsTitle: "Actualités & mises à jour",
  newsIntro:
    "Suivez nos dernières analyses d'approvisionnement, notes de lancement produit et mises à jour export pour les acheteurs d'accessoires fitness.",
  newsSectionTitle:
    "Pour les annonces de projets sur mesure ou les aperçus de nouvelles collections, contactez notre équipe commerciale pour obtenir le dernier catalogue.",

  news1Title: "Guide d'approvisionnement de printemps publié",
  news1Body:
    "Découvrez les dernières tendances en yoga, Pilates et produits de récupération pour la prochaine saison de vente.",
  news2Title: "Mises à jour sur l'emballage OEM",
  news2Body:
    "Nous proposons désormais davantage d'options d'emballage écologiques pour cartons, cartes d'insertion et codes-barres dans les programmes de marque privée.",
  news3Title: "Avis de calendrier d'exportation",
  news3Body:
    "Les délais et fenêtres d'expédition sont mis à jour chaque semaine pour aider les acheteurs à mieux planifier leurs lancements.",

  // --- contact ---
  contactHeroKicker: "Demande commerciale",
  contactTitle: "Contacter le fournisseur",
  contactIntro:
    "Partagez vos exigences produit et votre marché cible. Notre équipe vous répondra avec une offre et une estimation des délais.",
  contactFormTitle: "Envoyer la demande",
  contactName: "Votre nom",
  contactEmail: "E-mail professionnel",
  contactCompany: "Nom de l'entreprise",
  contactMessage: "Spécifications produit, quantité, destination d'expédition",
  contactSubmit: "Envoyer la demande",
  contactSent: "Message envoyé avec succès.",

  contactInfoTitle: "Bureau commercial",
  contactInfoEmail: "E-mail",
  contactInfoPhone: "Téléphone",
  contactInfoHours: "Horaires : Lun-Sam, 09:00-18:00 (GMT+8)",
  contactInfoNote:
    "Canaux recommandés : e-mail pour un devis formel, téléphone pour une confirmation urgente du planning de commande.",

  contactResponseTitle: "Délai moyen de réponse",
  contactResponseDesc:
    "Sous 8 heures ouvrées pour les demandes RFQ standard.",
  contactDocsTitle: "Documents disponibles",
  contactDocsDesc:
    "Facture commerciale, liste de colisage et support de coordination logistique.",
  contactSampleTitle: "Service d'échantillonnage",
  contactSampleDesc:
    "Mise en place rapide d'échantillons pour les projets OEM et marque blanche.",

  // --- about ---
  aboutTitle: "À propos de LOYA SPORT",
  aboutIntro:
    "LOYA SPORT est un intégrateur de chaîne d'approvisionnement pour produits de yoga, au service des acheteurs B2B mondiaux.",
  aboutWhoWeAre: "Qui sommes-nous",
  aboutWhoWeAreDesc1:
    "Nous accompagnons importateurs, distributeurs, détaillants et marques privées en coordonnant l'approvisionnement, les échantillons, le branding et le suivi des expéditions avec des partenaires fournisseurs vérifiés.",
  aboutWhoWeAreDesc2:
    "Notre force réside dans une communication pragmatique, une spécialisation catégorielle et un processus d'achat clair qui aide les clients internationaux à avancer plus vite.",

  aboutSupplyCapabilities: "Capacités d'approvisionnement",
  aboutSupplyList1:
    "Coordination de fournisseurs vérifiés pour les gammes yoga et fitness léger",
  aboutSupplyList2:
    "Contrôle qualité en plusieurs étapes avec des usines partenaires",
  aboutSupplyList3: "Support pour marque privée et emballage",
  aboutSupplyList4: "Support d'approvisionnement pour les marchés mondiaux",

  aboutProductDev: "Développement produit",
  aboutProductDevDesc:
    "Cycles d'échantillonnage rapides et collaboration design concrète pour accélérer la mise sur le marché.",
  aboutSupplyReliability: "Fiabilité de l'approvisionnement",
  aboutSupplyReliabilityDesc:
    "Approvisionnement stable en matériaux et planification de capacité pour maintenir les livraisons pendant les saisons de pointe.",
  aboutTradeSupport: "Support commercial",
  aboutTradeSupportDesc:
    "Documentation, coordination d'expédition et support après-vente pour des opérations internationales plus fluides.",

  aboutMission: "Notre mission",
  aboutMissionDesc:
    "Aider les marques fitness et les acheteurs de vente au detail a se developper grace a un approvisionnement fiable, un controle qualite strict et un support apres-vente complet.",

  searchOverlayPlaceholder: "Rechercher des produits par nom...",
  searchOverlaySubmitAria: "Valider la recherche",
  searchOverlaySubmitTitle: "Rechercher",
  searchOverlayHintPrefix: "Appuyez sur",
  searchOverlayHintSuffix:
    "pour afficher tous les produits correspondants, ou choisissez un résultat rapide ci-dessous.",
  searchOverlayCloseAria: "Fermer la recherche",
  searchOverlayQuickResults: "Résultats rapides",
  searchOverlayQuickResultsAria: "Résultats rapides de recherche",
  searchOverlayFallbackCategory: "Accessoires de yoga",
  searchOverlayHistory: "Historique de recherche",
  searchOverlayClear: "Effacer",
  searchOverlayNoHistory: "Aucune recherche récente",
  searchOverlayRecommended: "Mots-clés recommandés",
  searchOverlayFallbackKeyword: "Tapis de yoga",

  blogHeroKicker: "Centre de contenu",
  blogHeroTitle: "Insights et guides d'achat",
  blogSearchAria: "Rechercher des articles",
  blogCategoryAria: "Catégories d'articles",
  blogFeaturedPlaceholder: "Insight à la une",
  blogPaginationAria: "Pagination du blog",
  blogCtaAria: "Appel à l'action du blog",
  blogCtaDescription: "Notre équipe peut vous proposer des recommandations ciblées et vous accompagner des échantillons jusqu'à la livraison en volume.",
  blogCtaPrimary: "Contacter maintenant",
  blogCtaSecondary: "Voir les solutions",
  contactInquiryGreeting: "Bonjour, je souhaite me renseigner sur ce produit :",
  contactInquiryProductPrefix: "Produit :",
  contactInquiryQuantity: "Quantité :",
  contactInquiryDestinationPort: "Port de destination :",

  aboutHeroKicker: "Intégrateur supply chain",
  aboutHeroTitle:
    "Nous aidons les acheteurs internationaux à gérer sourcing, coordination usine et livraison export avec une seule équipe commerciale.",
  aboutHeroBody:
    "LOYA SPORT se positionne comme intégrateur supply chain pour les catégories yoga, pilates et fitness léger. Nous ne faisons pas que présenter des produits. Nous structurons fournisseurs, échantillons, emballage, suivi qualité et préparation d'expédition dans un processus d'achat opérationnel pour les clients internationaux.",
  aboutMetric1:
    "guichet projet unique pour la communication produit, emballage et livraison",
  aboutMetric2:
    "ressources usines coordonnées sous une seule structure sourcing et suivi",
  aboutMetric3:
    "workflow B2B concu pour importateurs, detailants, distributeurs et acheteurs de marque propre",
  aboutPlaceholderNote:
    "Notre rôle est de réduire la communication fragmentée entre acheteur, fournisseur et équipes d'exécution usine, afin que les projets avancent avec plus de clarté et moins d'angles morts.",
  aboutHeroImageAlt:
    "Réunion de coordination supply chain pour acheteurs export",
  aboutHeroCaption:
    "De la demande à l'expédition, nous coordonnons les détails qui sont habituellement dispersés entre agents de sourcing, usines et contacts logistiques.",
  aboutOfficeImageAlt: "Immeuble de bureaux Loya Technology à Changsha",
  aboutOfficeCaption: "Bureau Loya Technology de Changsha",
  aboutTeamImageAlt: "Notre équipe professionnelle au bureau de Changsha",
  aboutFactoryImageAlt: "Ligne de production de tapis de yoga et flux qualité",
  aboutFactoryCollageAlt: "Entrepôt usine et détails de production",
  aboutWhatWeDoTitle: "Ce que nous faisons concrètement",
  aboutWhatWeDoBody1:
    "Beaucoup d'acheteurs n'ont pas seulement besoin d'un catalogue. Ils ont besoin d'un partenaire qui relie les exigences commerciales à l'exécution réelle en usine. C'est notre rôle. Nous coordonnons sélection fournisseur, discussion prix, échantillonnage, exécution emballage, suivi production, alignement inspection et préparation export.",
  aboutWhatWeDoBody2:
    "Au lieu de laisser les détails produit, fichiers d'emballage, délais de livraison et changements de commande répartis entre plusieurs contacts, nous centralisons le processus et faisons avancer le projet via un parcours de communication responsable.",
  aboutBadge1: "Matching fournisseurs",
  aboutBadge2: "Suivi échantillons",
  aboutBadge3: "Exécution emballage",
  aboutBadge4: "Préparation expédition",
  aboutSideImageAlt: "Communication acheteur et revue de projet",
  aboutIntegratedCapabilitiesTitle:
    "Capacités supply chain intégrées",
  aboutSideCaption:
    "Nous visons à rendre la chaîne de sourcing plus simple à piloter pour les acheteurs internationaux qui ont besoin d'une coordination fiable plutôt que d'opérations commerciales isolées.",
  aboutCapabilityCard1Title: "Intégration du réseau fournisseurs",
  aboutCapabilityCard1Body:
    "Nous combinons ressources usines, expertise catégorie et contrôles sourcing dans un workflow orienté acheteur afin d'éviter la coordination multi-parties de votre côté.",
  aboutCapabilityCard2Title: "Coordination commerciale et technique",
  aboutCapabilityCard2Body:
    "De la cotation, des échantillons et des détails d'emballage jusqu'à la validation des specs et des checkpoints de production, nous alignons le commercial et l'usine.",
  aboutCapabilityCard3Title: "Exécution des commandes export",
  aboutCapabilityCard3Body:
    "Nous suivons les commandes via inspection, documentation, booking et préparation d'expédition pour réduire les écarts de communication et le risque de livraison.",
  aboutOperatingModel1:
    "Sourcing par catégorie et matching usine selon votre marché cible et votre positionnement prix.",
  aboutOperatingModel2:
    "Échantillonnage, revue des specs et coordination emballage avant verrouillage de production.",
  aboutOperatingModel3:
    "Suivi production, checkpoints qualité et préparation expédition dans un seul flux projet.",
  aboutOperatingModel4:
    "Fenêtre de communication unique pour produit, emballage, documentation et progression de livraison.",
  aboutWhoWeServeTitle: "Qui nous accompagnons",
  aboutBuyerScenario1Title: "Pour importateurs et distributeurs",
  aboutBuyerScenario1Body:
    "Nous aidons à consolider les gammes, comparer les options fournisseurs et construire un plan de réassort plus stable entre catégories.",
  aboutBuyerScenario2Title: "Pour enseignes de vente au detail et vendeurs e-commerce",
  aboutBuyerScenario2Body:
    "Nous soutenons des assortiments prets au lancement, l'emballage de marque propre et une communication pratique pour des commandes repetables.",
  aboutBuyerScenario3Title: "Pour marques en extension de gamme",
  aboutBuyerScenario3Body:
    "Nous agissons comme couche de coordination entre votre concept, la production et l'exécution export pour accélérer vos équipes internes.",
  aboutWorkflowTitle: "Comment notre workflow est structuré",
  aboutWorkflowStep1:
    "Collecte des besoins et clarification des produits cibles",
  aboutWorkflowStep2:
    "Matching fournisseurs, cotation et planification d'échantillons",
  aboutWorkflowStep3:
    "Revue spécifications, emballage et conformité",
  aboutWorkflowStep4:
    "Suivi production, inspection et préparation d'expédition",
  aboutWhyIntegratorTitle:
    "Pourquoi les acheteurs utilisent un intégrateur supply chain",
  aboutWhyIntegratorBody1:
    "Quand le sourcing implique plusieurs fournisseurs, partenaires d'emballage et calendriers d'expedition, le principal risque n'est generalement pas la premiere cotation. C'est la perte d'alignement une fois la commande lancee.",
  aboutWhyIntegratorList1:
    "Les spécifications peuvent dériver entre cotation et production.",
  aboutWhyIntegratorList2:
    "Les details d'emballage et de marque peuvent etre retardes par une communication fragmentee.",
  aboutWhyIntegratorList3:
    "Inspection, documentation et préparation d'expédition peuvent se déconnecter de la promesse commerciale initiale.",
  aboutWhyIntegratorBody2:
    "Notre valeur est de garder ces éléments connectés. Nous servons de couche de coordination entre attentes acheteur et exécution fournisseur pour documenter les décisions, suivre le timing et réduire le risque de handoff.",
  aboutTalkToTeam: "Parler à notre équipe",
  aboutPositioningTitle: "Notre positionnement",
  aboutPositioningBody:
    "LOYA SPORT se positionne comme intégrateur supply chain pour des produits fitness orientés export. Nous aidons les clients à acheter avec une coordination plus claire, une meilleure organisation fournisseur et un parcours plus maîtrisable du sourcing à l'expédition.",

  solutionsHeroKicker: "Solutions",
  solutionsHeroTitle:
    "Choisissez la bonne route de sourcing selon votre type d'acheteur",
  solutionsHeroBody:
    "Conçu comme un guide visuel pour l'adéquation canal, scénario et planification de programme produit.",
  solutionsTalkToSales: "Parler aux ventes",
  solutionsBrowseProducts: "Voir les produits",
  solutionsHeroImageAlt:
    "Solutions de sourcing B2B pour acheteurs yoga et fitness léger",
  solutionsHeroBadgeTitle: "Adéquation solution",
  solutionsHeroBadgeBody: "Type d'acheteur + cas d'usage + assortiment",
  solutionsBuyerTypeTitle: "Solutions par type d'acheteur",
  solutionsViewMatchingProducts: "Voir les produits correspondants",
  solutionsScenarioPlansTitle: "Plans par scénario",
  solutionsProgramMixesTitle: "Mix de programmes recommandés",
  solutionsNextStepKicker: "Étape suivante",
  solutionsNextStepTitle:
    "Besoin d'un mix adapté à votre marché ?",
  solutionsNextStepBody:
    "Partagez votre type d'acheteur, vos produits cibles et votre marché destination. Nous proposerons une route d'assortiment pragmatique.",
  solutionsRequestPlan: "Demander un plan de solution",
  solutionsExploreOem: "Explorer le support OEM",

  solutionsBuyerCard1Title: "Grossistes",
  solutionsBuyerCard1Subtitle:
    "Construction rapide d'assortiment pour programmes volumiques.",
  solutionsBuyerCard1Need1:
    "Besoin d'un approvisionnement bulk stable avec moins de risque de rupture",
  solutionsBuyerCard1Need2:
    "Besoin de mix SKU prêts carton pour accélérer la revente",
  solutionsBuyerCard1Need3:
    "Besoin de cycles de réassort récurrents avec lead time prévisible",
  solutionsBuyerCard1Tag1: "Assortiments bulk",
  solutionsBuyerCard1Tag2: "Packs prêts carton",
  solutionsBuyerCard1Tag3: "Réassort récurrent",

  solutionsBuyerCard2Title: "Detailants",
  solutionsBuyerCard2Subtitle:
    "Packs prêts rayon et réapprovisionnement régulier.",
  solutionsBuyerCard2Need1:
    "Besoin d'échelles de prix claires de l'entrée au premium",
  solutionsBuyerCard2Need2:
    "Besoin d'emballage code-barres pour accelerer le referencement en rayon",
  solutionsBuyerCard2Need3:
    "Besoin d'un réassort fiable pour les produits à forte rotation",
  solutionsBuyerCard2Tag1: "Packs detail",
  solutionsBuyerCard2Tag2: "Support code-barres",
  solutionsBuyerCard2Tag3: "Mix display-friendly",

  solutionsBuyerCard3Title: "Marques fitness",
  solutionsBuyerCard3Subtitle:
    "Programmes de marque propre pour l'extension de marque.",
  solutionsBuyerCard3Need1:
    "Besoin d'un branding personnalisé sans reconstruire toute la supply chain",
  solutionsBuyerCard3Need2:
    "Besoin de styles d'emballage alignés au positionnement de marque",
  solutionsBuyerCard3Need3:
    "Besoin de délais plus courts du sample au lancement",
  solutionsBuyerCard3Tag1: "Application logo",
  solutionsBuyerCard3Tag2: "Emballage personnalise",
  solutionsBuyerCard3Tag3: "Extension de gamme",

  solutionsBuyerCard4Title: "Studios de yoga",
  solutionsBuyerCard4Subtitle:
    "Kits studio, accessoires et ensembles de cours.",
  solutionsBuyerCard4Need1:
    "Besoin de kits de démarrage pour nouveaux membres et cours d'essai",
  solutionsBuyerCard4Need2:
    "Besoin d'accessoires durables pour sessions à haute fréquence",
  solutionsBuyerCard4Need3:
    "Besoin d'une tarification d'ensemble pragmatique pour l'upsell",
  solutionsBuyerCard4Tag1: "Sets de démarrage",
  solutionsBuyerCard4Tag2: "Accessoires de cours",
  solutionsBuyerCard4Tag3: "Kits upgrade membres",

  solutionsBuyerCard5Title: "Vendeurs Amazon",
  solutionsBuyerCard5Subtitle:
    "Ensembles et emballages prets pour marketplace.",
  solutionsBuyerCard5Need1:
    "Besoin d'une structure d'ensemble compacte pour maitriser les couts de transport",
  solutionsBuyerCard5Need2:
    "Besoin de combinaisons produit orientées conversion",
  solutionsBuyerCard5Need3:
    "Besoin d'une qualite d'emballage qui reduit les retours",
  solutionsBuyerCard5Tag1: "Ensembles compacts",
  solutionsBuyerCard5Tag2: "Emballage pret au listing",
  solutionsBuyerCard5Tag3: "Lancements low-friction",

  solutionsBuyerCard6Title: "Entreprises e-commerce",
  solutionsBuyerCard6Subtitle:
    "Produits visual-first pour ventes online récurrentes.",
  solutionsBuyerCard6Need1:
    "Besoin de SKUs hero performants en ads et trafic social",
  solutionsBuyerCard6Need2:
    "Besoin d'ensembles flexibles pour augmenter l'AOV",
  solutionsBuyerCard6Need3:
    "Besoin d'un refresh catalogue rapide pour campagnes saisonnières",
  solutionsBuyerCard6Tag1: "Produits hero",
  solutionsBuyerCard6Tag2: "Logique d'ensemble",
  solutionsBuyerCard6Tag3: "Refresh catalogue rapide",

  solutionsScenario1Title: "Sets de démarrage studio",
  solutionsScenario1Body:
    "Ensembles yoga prets au lancement pour cours, essais et packs membres.",
  solutionsScenario2Title: "Zones récupération et massage",
  solutionsScenario2Body:
    "Outils de massage, rollers et accessoires récupération pour corners de salle.",
  solutionsScenario3Title: "Programmes de presentation en detail",
  solutionsScenario3Body:
    "Assortiments equilibres avec emballage adapte a la presentation en rayon.",
  solutionsScenario4Title: "Offres d'ensembles en ligne",
  solutionsScenario4Body:
    "Kits compacts conçus pour des pages produit orientées conversion.",

  solutionsProgram1Title: "Mix lancement studio",
  solutionsProgram1Body:
    "Un assortiment de démarrage propre pour activités yoga orientées cours.",
  solutionsProgram1Item1: "Tapis de yoga",
  solutionsProgram1Item2: "Blocs & sangles",
  solutionsProgram1Item3: "Accessoires massage",
  solutionsProgram1SuitedFor: "Studios / coachs",

  solutionsProgram2Title: "Programme rayon detail",
  solutionsProgram2Body:
    "Famille produit équilibrée pour magasins ayant besoin d'échelles de prix claires et de commandes récurrentes.",
  solutionsProgram2Item1: "Tapis core",
  solutionsProgram2Item2: "Accessoires Pilates",
  solutionsProgram2Item3: "Outils récupération d'impulsion",
  solutionsProgram2SuitedFor: "Detailants / distributeurs",

  solutionsProgram3Title: "Pack d'ensemble en ligne",
  solutionsProgram3Body:
    "Sets compacts construits pour le visuel PDP et une conversion online facilitée.",
  solutionsProgram3Item1: "Mini kits",
  solutionsProgram3Item2: "Packs cadeaux",
  solutionsProgram3Item3: "Inserts marque propre",
  solutionsProgram3SuitedFor: "Amazon / e-commerce",

  admin: {
    ...(en.admin || {}),

    // --- categories / faq / company images ---
    productCategoryYogaMats: "Tapis de yoga",
    productCategoryYogaBlocks: "Blocs de yoga",
    productCategoryYogaStraps: "Sangles de yoga",
    productCategoryResistanceBands: "Bandes de résistance",
    productCategoryPilatesRings: "Anneaux de Pilates",
    productCategoryFoamRollers: "Rouleaux en mousse",
    productCategoryOthers: "Autres",

    faqSampleOrderQ: "Acceptez-vous les commandes d'échantillons ?",
    faqSampleOrderA:
      "Oui, nous acceptons les commandes d'échantillons, n'hésitez pas à nous contacter.",
    faqCustomPackagingQ:
      "Proposez-vous un service de personnalisation d'emballage et de logo ?",
    faqCustomPackagingA:
      "Oui, nous proposons des services OEM/ODM personnalisés.",
    faqLeadTimeQ: "Quel est votre délai de production ?",
    faqLeadTimeA:
      "Généralement 1 à 3 jours selon la quantité commandée. Le délai final sera confirmé lors de la commande.",
    faqDefectiveItemQ: "Comment traiter un article défectueux ?",
    faqDefectiveItemA:
      "Nous offrons UNE GARANTIE D'UN AN à compter de la date d'expédition. Pendant la période de garantie, si vous rencontrez un article défectueux dû à nos matériaux ou à notre fabrication, veuillez nous fournir les détails, y compris la description, des photos ou vidéos, et même un échantillon défectueux si nécessaire. Nos ingénieurs analyseront le problème et vous proposeront une solution. Si vous souhaitez retourner l'article, veuillez nous contacter et le renvoyer avec son emballage et ses accessoires d'origine. Le remboursement sera effectué dès réception des articles retournés ou un remplacement gratuit vous sera envoyé.",
    faqWhyChooseUsQ: "Pourquoi nous choisir ?",
    faqWhyChooseUsA:
      "Nos produits ont une MOQ faible et une haute qualité conforme aux normes américaines ou européennes. Nous fournissons un service de haut niveau, acceptons les commandes OEM et Trade Assurance. Vous pouvez expédier en toute sérénité.",

    companyImageSectionOverview: "Présentation de l'entreprise",
    companyImageSectionAdvantages: "Avantages concurrentiels",
    companyImageSectionCustomization: "Capacités de personnalisation",
    companyImageSectionExtended: "Profil d'entreprise détaillé",
    companyImageSectionPackaging: "Spécifications d'emballage et d'expédition",
    companyImageSectionFactory: "Profil de l'usine",
    companyImageSectionWorkflow: "Flux de production",
    companyImageSectionTradeShow: "Participation aux salons professionnels",

    // --- order status / tab descriptions ---
    orderStatusPaid: "Payée",
    orderStatusPacked: "Emballée",
    orderStatusInTransit: "En transit",
    orderStatusDelivered: "Livrée",
    orderStatusCancelled: "Annulée",

    tabDescHome:
      "Gérez les opérations de votre espace de travail et suivez les performances ici.",
    tabDescStoreBase:
      "Configurez les titres de la vitrine/admin et les métadonnées SEO.",
    tabDescTemplateStudio: "Éditez visuellement les modules de mise en page de la vitrine et enregistrez des modèles personnalisés.",
    tabDescArticleManagement:
      "Gérez les articles du blog dans un espace dédié avec édition via boîtes de dialogue.",
    tabDescCompanyImages:
      "Gérez les ressources d'images classées de l'entreprise pour le contenu du profil de la vitrine.",
    tabDescDesignNav:
      "Configurez la navigation de la vitrine et la structure des menus imbriqués.",
    tabDescDesignCarousel:
      "Gérez les images du carrousel de la section hero de votre vitrine.",
    tabDescDesignBanner:
      "Configurez les messages de bannière et les contenus d'appel à l'action.",
    tabDescFaqKnowledge:
      "Maintenez le contenu FAQ utilisé par les équipes commerciales et opérationnelles.",
    tabDescProducts:
      "Gérez le catalogue produit, les détails et les informations tarifaires.",
    tabDescProductCreate:
      "Créez un nouveau produit avec tous les détails et médias.",
    tabDescMerchandising:
      "Évaluez les produits candidats, la structure tarifaire et la préparation au lancement.",
    tabDescProcurement:
      "Coordonnez les plans d'achat, l'avancement des fournisseurs et les priorités d'approvisionnement.",
    tabDescQuality:
      "Suivez les points de contrôle et la préparation à la libération avant exécution.",
    tabDescLogistics:
      "Suivez l'état des expéditions, la préparation des emballages et la collaboration de suivi.",
    tabDescOrders:
      "Suivez le cycle de vie des commandes, l'exécution et les mises à jour d'expédition.",
    tabDescCustomers:
      "Gérez les membres de votre équipe et leurs autorisations de compte ici.",
    tabDescMarketing:
      "Consultez l'état des campagnes et les performances de croissance.",
    tabDescDiscounts:
      "Gérez la stratégie de remise et les règles promotionnelles.",
    tabDescFinance: "Surveillez les registres financiers et les tendances de revenus.",
    tabDescFinanceIncome: "Consultez les encaissements de commandes, les revenus reconnus et les entrées du grand livre des revenus.",
    tabDescFinanceExpenses: "Suivez les factures d'achats, de logistique, de marketing et de frais généraux.",
    tabDescFinanceReceivables: "Suivez les créances, leur ancienneté et les priorités de recouvrement.",
    tabDescFinancePayables: "Gérez les dettes fournisseurs, les paiements et les échéances urgentes.",
    tabDescFinanceInvoices: "Maintenez les factures, les reçus et le statut de facturation.",
    tabDescFinanceTax: "Consultez la TVA collectée, la TVA déductible et les estimations fiscales.",
    tabDescFinanceBudget: "Suivez les budgets, la répartition des dépenses et les alertes de dépassement.",
    tabDescFinanceDaily: "Résumez les revenus, dépenses et trésorerie nette de la société par jour.",
    tabDescFinanceMonthly: "Clôturez les livres mensuels et examinez les bénéfices et les écarts budgétaires.",
    tabDescFinanceYearly: "Examinez le chiffre d'affaires annuel, les dépenses, la fiscalité et le bénéfice net.",
    tabDescFinanceReconciliation: "Rapprochez créances, encaissements, dettes, factures et état fiscal.",
    tabDescFinanceApprovals: "Gérez les audits d'approbation de remboursements, paiements et dépenses.",
    tabDescFinanceReports: "Synthétisez états financiers, indicateurs opérationnels et travaux d'exportation.",
    tabDescAnalytics:
      "Analysez les données et les indicateurs opérationnels.",
    tabDescSettings:
      "Gérez les paramètres système de bas niveau comme la connexion à la base de données.",
    tabDescWorkTargets: "Suivez et coordonnez les objectifs de tâches quotidiennes.",
    tabDescWorkProcessing:
      "Traitez les flux de travail assignés et les enregistrements d'exécution.",
    tabDescHrEmployee:
      "Consultez et maintenez les profils employés et les informations de compte.",
    tabDescHrRecruitment:
      "Suivez la file de tâches liées au recrutement et à l'intégration.",
    tabDescHrAttendance:
      "Surveillez l'assiduité du personnel et le statut d'activité des comptes.",
    tabDescHrOffice:
      "Gérez la couverture des postes et les tâches administratives internes.",
    tabDescSiteMaintenance:
      "Maintenez le contenu de la vitrine et la stabilité du site.",
    tabDescPermissionMaintenance:
      "Maintenez les autorisations basées sur les rôles et les limites d'accès.",
    tabDescPositionMaintenance: "",
    tabDescProfile: "Consultez les informations de votre compte.",
    tabDescPassword:
      "Modifiez le mot de passe de votre compte en toute sécurité.",
    tabDescInquiry:
      "Contactez le vendeur et poursuivez la communication de demande.",
    tabDescWishlist:
      "Gérez les produits enregistrés et vos articles d'approvisionnement préférés.",
    tabDescOrderProcessing:
      "Suivez et traitez les enregistrements du cycle de vie des commandes.",
    tabDescAfterSales:
      "Assurez le suivi des demandes après-vente et des tickets de support.",

    // --- roles / menus ---
    roleDeveloper: "Développeur",
    roleSuperAdmin: "Super administrateur",
    roleAdmin: "Administrateur",
    roleCustomer: "Client",
    roleGuest: "Invité",

    productCreateMenu: "Publication de produit",
    productsMenu: "Gestion des produits",
    merchandisingOverview: "Vue d'ensemble du merchandising",
    merchandisingCollection: "Pool collecté",
    internalOverview: "Vue d'ensemble & configuration",
    internalWorkspace: "Catalogue & exécution",
    internalBusiness: "Ventes & clients",
    internalOffice: "Espace de travail par poste",
    internalMaintenance: "Panneau de maintenance",
    storefrontContent: "Contenu de la vitrine",
    guestService: "Services invités",
    customerService: "Services client",
    commonAccount: "Mon compte",
    siteMaintenanceMenu: "Gestion des postes",
    positionMaintenanceMenu: "Gestion des utilisateurs",

    title: "Ma boutique",
    home: "Vue d'ensemble des opérations",
    storeDesign: "Configuration de la vitrine",
    companyProfile: "Profil de l'entreprise",
    storeBase: "Paramètres de base de la boutique",
    templateStudio: "Studio de modèles",
    articleManagement: "Gestion des articles",
    companyProfileMenu: "Présentation de l'entreprise",
    companyImages: "Images de l'entreprise",
    designNav: "Menu de navigation",
    designCarousel: "Carrousel de la page d'accueil",
    designBanner: "Paramètres de bannière",
    faqKnowledge: "Base de connaissances FAQ",
    products: "Gestion des produits",
    productCreate: "Créer un produit",
    merchandising: "Centre de merchandising",
    procurement: "Centre d'approvisionnement",
    quality: "Centre qualité",
    logistics: "Collaboration logistique",
    orders: "Demandes & commandes",
    customers: "Gestion des clients",
    marketing: "Campagnes",
    discounts: "Stratégie tarifaire",
    finance: "Vue financière",
    financeIncome: "Livre des revenus",
    financeExpenses: "Factures de dépenses",
    financeReceivables: "Créances clients",
    financePayables: "Dettes fournisseurs",
    financeInvoices: "Gestion des factures",
    financeTax: "Gestion fiscale",
    financeBudget: "Budget et dépenses",
    financeDaily: "Factures journalières",
    financeMonthly: "Clôture mensuelle",
    financeYearly: "États annuels",
    financeReconciliation: "Rapprochement",
    financeApprovals: "Approbations et audit",
    financeReports: "Rapports et export",
    analytics: "Analyse des données",
    settings: "Paramètres système",

    menuCommon: "Commun",
    menuInternal: "Interne",
    menuWorkContent: "Contenu de travail",
    menuMaintenance: "Panneau de maintenance",
    userManagementGroup: "Panneau de maintenance",
    menuGuest: "Invité",
    menuCustomer: "Client",

    workTargets: "Objectifs de tâches",
    workProcessing: "Traitement du travail",
    hrEmployee: "Profils employés",
    hrRecruitment: "Recrutement",
    hrAttendance: "Présence",
    hrOffice: "Administration de bureau",
    siteMaintenance: "Maintenance des postes",
    permissionMaintenance: "Gestion des autorisations",
    positionMaintenance: "Gestion des utilisateurs",
    profile: "Mon profil",
    password: "Changer le mot de passe",
    inquiry: "Messages de demande",
    wishlist: "Liste d'envies",
    orderProcessing: "Traitement des commandes",
    afterSales: "Service après-vente",

    // --- profile / password / inquiry ---
    profileCardTitle: "Informations personnelles",
    accountId: "ID du compte",
    profileName: "Nom",
    profileEmail: "E-mail",
    profileRole: "Rôle",

    passwordCardTitle: "Mettre à jour le mot de passe du compte",
    currentPassword: "Mot de passe actuel",
    adminResetPasswordHint:
      "Cette action réinitialise le mot de passe de l'utilisateur cible. Son mot de passe actuel n'est pas requis.",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le nouveau mot de passe",
    savePassword: "Mettre à jour le mot de passe",
    passwordUpdated: "Mot de passe mis à jour avec succès.",

    inquiryCardTitle: "Communication de demande",
    inquiryCardBody:
      "Contactez l'équipe vendeuse pour discuter des exigences produit, des devis et des plans de livraison.",
    openInquiryCenter: "Ouvrir la page de contact",
    openWhatsappChat: "Discussion WhatsApp",

    permissionSectionTitle: "Ensemble d'autorisations actuel",
    permissionSectionBody:
      "Les autorisations sont résolues à partir des données de connexion et associées à la structure de votre poste.",
    placeholderTodo:
      "Ce module est activé pour votre poste. Vous pouvez étendre ici les actions métier concrètes.",

    // --- settings / system / base ---
    systemConfigTitle: "Centre des paramètres système",
    settingsTabDatabase: "Base de données",
    settingsTabDatabaseHint: "Connexion et paramètres du pool",
    settingsTabEmail: "E-mail",
    settingsTabEmailHint: "Branding et modèles transactionnels",

    mysqlHost: "Hôte MySQL",
    mysqlPort: "Port MySQL",
    mysqlDatabase: "Base de données MySQL",
    mysqlUser: "Utilisateur MySQL",
    mysqlPassword: "Mot de passe MySQL",
    mysqlPoolSize: "Taille du pool MySQL",
    mysqlConnectTimeoutMs: "Délai de connexion MySQL (ms)",

    saveSystemConfig: "Enregistrer les paramètres système",
    systemConfigSavedToast: "Configuration système enregistrée",
    systemConfigPathLabel: "Fichier de configuration",
    restartRequiredHint:
      "Redémarrez le backend après l'enregistrement pour appliquer les nouveaux paramètres BD.",

    storefrontTitle: "Titre de la vitrine",
    adminTitle: "Titre du panneau d'administration",
    seoMetaTitle: "Titre méta SEO",
    seoDescription: "Description méta SEO",
    seoKeywords: "Mots-clés SEO",
    seoCanonicalUrl: "URL canonique",
    seoRobots: "SEO robots",
    seoOgTitle: "Titre Open Graph",
    seoOgDescription: "Description Open Graph",
    seoOgImage: "URL de l'image Open Graph",
    seoTwitterCard: "Type de carte Twitter",
    seoTwitterSite: "Compte/site Twitter",

    saveBaseSettings: "Enregistrer les paramètres de base",
    baseSavedToast: "Paramètres de base enregistrés",

    // --- common ui ---
    hello: "Bonjour, commençons.",
    askAnything: "Demandez n'importe quoi...",
    supportLine: "Besoin d'aide ? Contactez le support",

    addStoreName: "Ajouter le nom de la boutique",
    firstProduct: "Ajoutez votre premier produit",
    firstProductDesc:
      "Commencez par ajouter un produit et ses informations clés pour préparer les ventes.",
    addProduct: "Ajouter un produit",
    importData: "Importer",

    customizeStore: "Personnaliser la boutique en ligne",
    customizeStoreDesc:
      "Choisissez un modèle, puis ajoutez votre logo, vos couleurs et vos images.",
    customTemplate: "Modèle personnalisé",
    payments: "Configurer les paiements",
    shipping: "Vérifier les tarifs d'expédition",
    domain: "Domaine personnalisé",

    quickSales: "Simplifier les ventes multicanales",
    quickSalesDesc:
      "Gérez vos listings sur plusieurs marketplaces depuis un seul endroit.",

    storeSettings: "Paramètres de la boutique",
    general: "Général",
    billing: "Facturation",
    usersPermissions: "Utilisateurs",

    paginationPrevious: "Précédent",
    paginationNext: "Suivant",
    paginationPage: "Page",
    paginationTotal: "Total",

    policies: "Politiques",
    businessInfo: "Informations de l'entreprise",
    contactInfo: "Contact de la boutique",
    defaults: "Paramètres par défaut de la boutique",

    businessMode: "Mode commercial",
    b2b: "B2B",
    b2c: "B2C",
    modeSaved: "Mode de boutique mis à jour",
    modeSavedToast: "Mode commercial changé avec succès",

    navSettings: "Menu de navigation",
    navLabel: "Nom du sous-menu",
    navPath: "Lien du sous-menu",
    addSubmenu: "Ajouter un sous-menu",
    saveNavigation: "Enregistrer la liste des sous-menus",
    navSavedToast: "Menu de navigation enregistré",

    bannerSettings: "Liste du carrousel",
    bannerTitle: "Titre de bannière",
    bannerAnnotation: "Annotation de l'image",
    bannerButtonText: "Nom du bouton",
    bannerButtonLink: "Lien du bouton",
    bannerImageUrl: "URL de l'image de bannière",
    addBanner: "Ajouter une bannière",
    removeBanner: "Supprimer",
    saveBanners: "Enregistrer la liste du carrousel",
    bannersSavedToast: "Liste du carrousel enregistrée",

    saveFaqKnowledge: "Enregistrer la base FAQ",
    faqKnowledgeSavedToast: "Base FAQ enregistrée",
    saveCompanyImages: "Enregistrer les images de l'entreprise",
    companyImagesSavedToast:
      "Configuration des images de l'entreprise enregistrée",

    companyIntroductionTitle: "Présentation de l'entreprise",
    companyIntroductionHint:
      "Décrivez le profil de votre entreprise, ses points forts et ses capacités de service.",
    companyIntroductionPlaceholder:
      "Saisissez le contenu de présentation de l'entreprise...",
    addImageUrl: "Ajouter une URL d'image",
    uploadLocalImages: "Téléverser des images locales",
    addFaq: "Ajouter une FAQ",
    saveCarouselImages: "Enregistrer les images du carrousel",
    carouselImagesSavedToast: "Images du carrousel enregistrées",

    close: "Fermer",
    save: "Enregistrer",
    create: "Créer",
    search: "Rechercher dans l'onglet actuel",
    refresh: "Actualiser",
    createProduct: "Créer un produit",
    cancel: "Annuler",
    edit: "Modifier",
    remove: "Supprimer",

    systemSnapshot: "Instantané système",
    activeSearch: "Recherche dans l'onglet actif",
    none: "(aucun)",
    orderRecords: "Enregistrements de commandes",
    userRecords: "Enregistrements utilisateurs",
    lastRefresh: "Dernière actualisation",
    productsCount: "Produits",
    customersCount: "Clients",
    ordersCount: "Commandes",
    revenue: "Revenu USD",

    localeLabel: "Langue",
    sku: "SKU",
    name: "Nom",
    description: "Description",
    price: "Prix USD",
    imageUrl: "URL de l'image",
    category: "Catégorie",
    model: "Modèle",
    titleField: "Titre du produit",
    detailVideo: "URL de la vidéo détaillée",
    mainImages: "Images principales (6 URL, une par ligne)",
    detailImages: "Images détaillées (URL, une par ligne)",
    parameters: "Paramètres (une ligne par entrée : clé:valeur)",
    openCreateProduct: "Ouvrir le formulaire de détail produit",

    id: "ID",
    serialNumber: "N°",
    userId: "ID utilisateur",
    actions: "Actions",
    email: "E-mail",
    role: "Rôle",
    username: "Nom d'utilisateur",
    nickname: "Surnom",
    userRole: "Rôle utilisateur",
    phone: "Numéro de téléphone",
    accountStatus: "Statut du compte",
    jobTitle: "Intitulé du poste",
    registeredAt: "Date d'inscription",
    lastActiveAt: "Dernière activité",
    statusActive: "Actif",
    statusDisactive: "Inactif",
    permissions: "Autorisations",
    position: "Poste",
    accessSummary: "Accès",
    positionName: "Nom du poste",
    positionKey: "Clé du poste",
    department: "Département",
    addPosition: "Ajouter un poste",
    permissionName: "Nom de l'autorisation",
    permissionKey: "Clé de l'autorisation",
    addPermission: "Ajouter une autorisation",
    editPermissions: "Modifier les autorisations",
    permissionSelectTitle: "Sélectionner les autorisations",
    permissionSelectedSummary: "Autorisations sélectionnées",
    permissionQuickSearchPlaceholder:
      "Recherche rapide par clé ou annotation",
    defaultAdminPosition: "Administrateur des opérations",

    orderId: "Commande",
    total: "Total",
    status: "Statut",
    cartItems: "Articles du panier",
    logout: "Se déconnecter",
    changePasswordAction: "Changer le mot de passe",
    userPasswordModalTitle: "Réinitialiser le mot de passe utilisateur",
    userPasswordUpdated: "Mot de passe utilisateur mis à jour avec succès.",
    targetUser: "Utilisateur cible",
    userDataResyncedHint:
      "Les champs du profil ont été resynchronisés depuis le serveur après l'enregistrement.",
    userManagementRestrictedHint:
      "Un niveau d'autorisation supérieur est requis pour cette opération.",

    capability: {
      ...((en.admin && en.admin.capability) || {}),

      "admin:overview:read": "Voir la vue d'ensemble d'administration",
      "admin:products:read": "Voir les produits d'administration",
      "admin:products:write": "Modifier les produits d'administration",
      "admin:orders:read": "Voir les commandes d'administration",
      "admin:orders:write": "Modifier les commandes d'administration",
      "admin:users:read": "Voir les utilisateurs d'administration",
      "admin:users:role:write": "Modifier les rôles utilisateurs",
      "admin:users:position:assign": "Attribuer des postes aux utilisateurs",
      "admin:storefront:read": "Voir les paramètres de la vitrine",
      "admin:storefront:write": "Modifier les paramètres de la vitrine",
      "admin:system-config:read": "Voir la configuration système",
      "admin:system-config:write": "Modifier la configuration système",
      "shop:profile:read": "Voir le profil de la boutique",
      "shop:password:write": "Mettre à jour le mot de passe de la boutique",
      "shop:orders:read": "Voir les commandes de la boutique",
      "shop:inquiry:write": "Traiter les demandes de la boutique",
      "shop:wishlist:read": "Voir la liste d'envies",
      "shop:orders:processing:read": "Voir le traitement des commandes",
      "shop:after-sales:read": "Voir l'après-vente",
      "internal:work:targets:read": "Voir les objectifs de travail",
      "internal:work:processing:read": "Voir le traitement du travail",
      "internal:maintenance:site:write": "Modifier la maintenance du site",
      "internal:maintenance:permission:write":
        "Modifier la gestion des autorisations",
      "internal:maintenance:position:write":
        "Modifier la gestion des postes",
      "shop:products:read": "Voir les produits de la boutique",
      "shop:storefront:read": "Voir la vitrine",
      "internal:system:config:read":
        "Voir la configuration système interne",
      "internal:system:config:write":
        "Modifier la configuration système interne",
      "internal:security:audit:read": "Voir les audits de sécurité",
      "internal:security:session:revoke": "Révoquer les sessions",
      "internal:integration:manage": "Gérer les intégrations",
      "admin:users:write": "Modifier les utilisateurs d'administration",
      "admin:users:password:reset":
        "Réinitialiser les mots de passe utilisateur",
      "admin:users:delete": "Supprimer les utilisateurs d'administration",
      "crm:customer:read": "Voir les fiches clients",
      "crm:customer:write": "Modifier les fiches clients",
      "crm:customer:assign": "Attribuer des clients",
      "website:content:read": "Voir le contenu du site",
      "website:content:write": "Modifier le contenu du site",
      "website:navigation:write": "Modifier la navigation du site",
      "website:banner:write": "Modifier les bannières du site",
      "website:seo:write": "Modifier les paramètres SEO",
      "website:theme:write": "Modifier le thème du site",
      "website:publish": "Publier le contenu du site",
      "admin:products:create": "Créer des produits d'administration",
      "admin:products:delete": "Supprimer des produits d'administration",
      "merchandising:selection:read": "Voir la sélection merchandising",
      "merchandising:selection:write":
        "Modifier la sélection merchandising",
      "catalog:pricing:write": "Modifier les prix du catalogue",
      "catalog:inventory:write": "Modifier le stock",
      "catalog:translation:write": "Modifier les traductions du catalogue",
      "sales:inquiry:read": "Voir les demandes commerciales",
      "sales:inquiry:reply": "Répondre aux demandes commerciales",
      "sales:quotation:create": "Créer des devis",
      "sales:quotation:approve": "Approuver les devis",
      "sales:contract:write": "Modifier les contrats commerciaux",
      "sales:sample:manage": "Gérer les échantillons",
      "order:status:update": "Mettre à jour le statut des commandes",
      "order:split:merge": "Scinder ou fusionner des commandes",
      "procurement:purchase:write": "Modifier les commandes d'achat",
      "production:plan:write": "Modifier les plans de production",
      "qa:inspection:write": "Modifier les inspections qualité",
      "logistics:shipment:write": "Modifier les enregistrements d'expédition",
      "logistics:tracking:read": "Voir le suivi des expéditions",
      "trade:customs:doc:write": "Modifier les documents douaniers",
      "finance:invoice:read": "Voir les factures",
      "finance:invoice:write": "Modifier les factures",
      "finance:payment:read": "Voir les paiements",
      "finance:payment:write": "Modifier les paiements",
      "finance:refund:approve": "Approuver les remboursements",
      "finance:reconciliation:write":
        "Modifier les enregistrements de rapprochement",
      "finance:tax:write": "Modifier les paramètres fiscaux",
      "marketing:campaign:read": "Voir les campagnes marketing",
      "marketing:campaign:write": "Modifier les campagnes marketing",
      "marketing:coupon:write": "Modifier les coupons",
      "marketing:lead:export": "Exporter les prospects",
      "analytics:dashboard:read": "Voir le tableau de bord analytique",
      "analytics:report:export": "Exporter les rapports analytiques",
      "support:ticket:read": "Voir les tickets de support",
      "support:ticket:write": "Modifier les tickets de support",
      "support:return:approve": "Approuver les retours",
      "support:complaint:handle": "Traiter les réclamations",
      "office:announcement:write": "Publier des annonces",
      "office:document:read": "Voir les documents de bureau",
      "office:document:write": "Modifier les documents de bureau",
      "office:workflow:approve": "Approuver les flux de travail internes",
      "office:meeting:manage": "Gérer les réunions",
      "hr:employee:read": "Voir les profils employés",
      "hr:employee:write": "Modifier les profils employés"
    }
  },
  blogReadingTimeMin: "min de lecture",
  blogShowLess: "Afficher moins",
  requestFreeSample: "Demander un echantillon gratuit",
  factoryStatsSince: "Depuis 1995",
  factoryStatsCapacity: "Plus de 10 000 unites par mois",
  factoryStatsExport: "Export vers plus de 50 pays",
  factoryStatsCert: "Certifie ISO 9001 et BSCI",
  aboutAddress: "Adresse : Batiment Ruihe Kechuang, Wanglong Road, district de Yuelu, Changsha, Hunan, Chine",
  aboutTeamTitle: "Equipe dynamique et professionnelle",
  aboutTeamBody: "Nous sommes une equipe jeune et experimentee, avec une solide comprehension des besoins du marche et des details techniques du secteur yoga. Grace a une logique de selection rigoureuse et une reactivite elevee, nous garantissons que chaque livraison repond a des attentes commerciales elevees.",
  aboutCustomizationTitle: "Services complets de personnalisation",
  aboutCustomizationBody: "De l'impression du logo et du design d'emballage au developpement de moules fonctionnels, nous proposons des solutions de personnalisation flexibles et approfondies pour aider votre marque a se demarquer.",
  aboutFactoryPartnerTitle: "Partenaires usine premium",
  aboutFactoryPartnerBody: "Nous collaborons etroitement avec des bases de production certifiees ISO/BSCI, en controlant la qualite a la source pour garantir la stabilite de production et la ponctualite des livraisons.",
  oemServiceShowcaseAria: "Services de personnalisation OEM et ODM",
  oemServiceShowcaseTitle: "Services de personnalisation OEM et ODM",
  oemServiceShowcaseBody: "Un accompagnement flexible de bout en bout, de la revue du concept a la production et a la livraison.",
  oemCompareHeadBody: "Quatre parcours courants, presentes en version de base versus resultat personnalise.",
  oemCompareBaseSuffix: "version de base",
  oemCompareOptionsSuffix: "options de personnalisation",
  oemCompareCustomizedSuffix: "version personnalisee",
  oemCompare1Title: "Application du logo",
  oemCompare1Body: "D'un produit neutre a une presentation de marque.",
  oemCompare1BeforeLabel: "Base",
  oemCompare1AfterLabel: "Avec logo",
  oemCompare1CustomizationLabel: "Ajout de logo",
  oemCompare1Item1: "Impression",
  oemCompare1Item2: "Gaufrage",
  oemCompare1Item3: "Marquage laser",
  oemCompare2Title: "Couleur et finition",
  oemCompare2Body: "D'une spec neutre a une couleur adaptee au marche.",
  oemCompare2BeforeLabel: "Standard",
  oemCompare2AfterLabel: "Couleur personnalisee",
  oemCompare2CustomizationLabel: "Mise a jour couleur",
  oemCompare2Item1: "Couleur",
  oemCompare2Item2: "Texture",
  oemCompare2Item3: "Taille",
  oemCompare3Title: "Configuration d'emballage",
  oemCompare3Body: "D'un emballage simple a une presentation prete pour la vente au detail.",
  oemCompare3BeforeLabel: "Emballage simple",
  oemCompare3AfterLabel: "Pret vente detail",
  oemCompare3CustomizationLabel: "Details d'emballage",
  oemCompare3Item1: "Carte d'insertion",
  oemCompare3Item2: "Code-barres",
  oemCompare3Item3: "Marquage carton",
  oemCompare4Title: "Developpement d'ensembles",
  oemCompare4Body: "D'articles unitaires a un set pret pour le canal.",
  oemCompare4BeforeLabel: "Articles unitaires",
  oemCompare4AfterLabel: "Ensemble combine",
  oemCompare4CustomizationLabel: "Logique d'ensemble",
  oemCompare4Item1: "Set studio",
  oemCompare4Item2: "Pack Amazon",
  oemCompare4Item3: "Mix promo",
  oemCasesTitle: "Cas de personnalisation",
  oemCase1Title: "Ligne de demarrage studio boutique",
  oemCase1Summary: "Presentation de kit de depart pour lancement de studio boutique.",
  oemCase1Details: "Kit avec logo valide en 12 jours.",
  oemCase2Title: "Mise a jour de marque propre pour la vente au detail",
  oemCase2Summary: "Mise a jour visuelle de l'emballage pour une meilleure presence en rayon.",
  oemCase2Details: "Validation acheteur plus rapide et meilleure coherence en vente au detail.",
  oemCase3Title: "Ensemble fitness pret marketplace",
  oemCase3Summary: "Configuration d'ensemble preparee pour e-commerce et fiches produit.",
  oemCase3Details: "Insert, code-barres et revue pour production de masse prets.",
  oemOrderingFlowKicker: "Parcours de commande",
  oemOrderingFlowTitle: "Contact et commande en cinq etapes",
  oemContactFlow1: "Demande initiale avec liste produit, marche cible et besoin branding.",
  oemContactFlow2: "Devis avec plan echantillon, delai et options d'emballage.",
  oemContactFlow3: "Validation echantillon et confirmation des details de commande.",
  oemContactFlow4: "Acompte, production, inspection et reservation d'expedition.",
  oemContactFlow5: "Paiement du solde, documents export et suivi apres-vente.",
  oemContactSideTitle: "Pret a discuter de votre demande OEM ?",
  oemContactSideBody: "Envoyez votre logo, votre objectif de quantite et votre idee d'emballage. Nous vous repondrons avec une voie de devis pratique et une recommandation echantillon.",
  oemContactSideNote: "Canal de premier contact recommande : email ou formulaire de demande avec artwork et fenetre d'expedition cible.",
  oemContactSideCta: "Contacter l'equipe commerciale",
  requestQuote: "Demander un devis",
  trustTitle: "Partenaires mondiaux et confiance",
  factoryStatsSize: "Usine de 30 000 m2",
  factoryStatsQC: "100% controle qualite en ligne et final",
  homeAriaTrust: "Confiance et partenaires",
  homeAriaStats: "Donnees et capacites usine",
};
